import React from 'react';
import { FaQuoteLeft, FaQuoteRight } from 'react-icons/fa';
import { IMemory } from 'btdt-types';
import './MemorySummary.css';

interface IProps {
  memory: IMemory;
}

function MemorySummary({ memory }: IProps): React.ReactElement {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const [isClamped, setIsClamped] = React.useState(false);
  const textRef = React.useRef<HTMLSpanElement>(null);

  React.useEffect(() => {
    const el = textRef.current;
    if (el) {
      setIsClamped(el.scrollHeight > el.clientHeight);
    }
  }, [memory.content]);

  return (
    <span className={`MemorySummary MemorySummary-${isExpanded ? 'expanded' : 'collapsed'}`} onClick={() => setIsExpanded(!isExpanded)}>
      <span className="MemorySummary-content">
        <FaQuoteRight />
        <span className="MemorySummary-content-text" ref={textRef}>
          {memory.content}
        </span>
        {(isExpanded || !isClamped) && <FaQuoteLeft />}
      </span>
      {!isExpanded && isClamped && <span className="MemorySummary-expand-hint">עוד...</span>}
      <small>— {memory.isAnonymous ? 'אנונימי.ת' : memory.userName}</small>
    </span>
  )
}

export default MemorySummary;
